import React from 'react';

export const useValidator = (t, setErrors) => React.useCallback(
    (value) => {
        const newValue = (value ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 11);
        const swiftError = newValue.length < 8
            ? [t('international_transfers_mexico_swift_code_error_length')]
            : null;

        setErrors((prevState) => ({
            ...prevState,
            swift_code: swiftError,
        }));

        return newValue;
    },
    [t, setErrors],
);
